import { FROM_OWNER_TOOLTIP_EXPERIMENT } from '../external/experiments';

export const EXPERIMENTS = Array.of<string>(
  /**
   * @todo Удалить строку с экспериментом
   * @description Данный функционал появился в задаче CD-161150, будет удалён в задаче CD-161151
   */
  FROM_OWNER_TOOLTIP_EXPERIMENT,
);
